function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export default function SoopBrand(props) {
    return /*#__PURE__*/ _jsx("svg", _object_spread_props(_object_spread({
        viewBox: "0 0 732 248",
        fill: "currentColor"
    }, props), {
        children: /*#__PURE__*/ _jsx("path", {
            fill: "currentColor",
            d: "M444 24c-29.6 0-56.2 12.9-74.5 33.3-.8.9-2.1.9-2.9 0C348.2 36.9 321.6 24 292 24c-55.2 0-100 44.8-100 100s44.8 100 100 100c29.6 0 56.2-12.9 74.5-33.3.8-.9 2.1-.9 2.9 0 18.3 20.5 44.9 33.3 74.5 33.3 55.2 0 100-44.8 100-100S499.2 24 444 24zm0 152c-16 0-29.4-7.7-37.6-16.4-2.6-2.8-5.9-6.6-9.4-9.8-1.7-1.5-3.4-2.9-5-4.2-6.7-4.8-15-7.6-24-7.6s-17.3 2.8-24 7.6c-1.6 1.2-3.3 2.6-5 4.2-3.6 3.2-6.8 7-9.4 9.8-8.2 8.7-21.6 16.4-37.6 16.4h-1.2c-.7 0-1.4 0-2.1-.1-.5 0-.9-.1-1.4-.1-.3 0-.6-.1-.8-.1C260.4 173 240 150.9 240 124v.2-.4.2c0-26.8 20.4-48.9 46.5-51.7.3 0 .6-.1.9-.1.4 0 .9-.1 1.4-.1.7 0 1.4-.1 2.1-.1h1.2c16 0 29.4 7.7 37.6 16.4 2.6 2.8 5.9 6.6 9.4 9.8 1.7 1.5 3.4 2.9 5 4.2 6.7 4.8 15 7.6 24 7.6s17.3-2.8 24-7.6c1.6-1.2 3.3-2.6 5-4.2 3.6-3.2 6.8-7 9.4-9.8C414.6 79.7 428 72 444 72h1.2c.7 0 1.4 0 2.1.1.4 0 .9.1 1.3.1.3 0 .6.1.9.1 25.1 2.7 44.9 23.2 46.4 48.7v5.9c-1.4 25.5-21.2 46.1-46.4 48.8-.3 0-.6.1-.9.1-.4 0-.9.1-1.3.1-.7 0-1.4.1-2.1.1-.4-.1-.8 0-1.2 0zM101.8 96.5l29.8 9.7C136 108 152 112 164 124c11.1 11.1 16 25.8 16 40.2 0 43.8-45.2 59.8-78 59.8-50 0-71.6-22.1-78-28l29.6-37.8C55.7 161.1 76 180 102 180c10 0 26-4 26-16 0-8-8.2-14.3-26-20l-29.7-9.7C51.8 126.2 36 112 36 84c0-15.3 5.9-27 8.6-31.2C61.2 26.9 94.5 24 106 24c20.3 0 35.2 3.7 46.1 8.3 13.8 5.8 21 13 23.9 15.7l-24.6 31.5C123.2 62.1 105.7 63.4 96 66.8c-6.6 2.3-8.7 7.6-9 11-.4 4.2.3 13.3 14.8 18.7zM644 25h-80v198h48v-66h32c33.7 0 64-20 64-66s-30.3-66-64-66zm16 66c0 14.4-11.6 26-26 26h-22V65h22c14.4 0 26 11.6 26 26z"
        })
    }));
}
